import React, { useState } from "react";
import DescriptionView from "./DescriptionView";
import DetailsView from "./DetailsView";
import EmployementTermsView from "./EmployementTermsView";
import svg85 from "../../../../assets/svg/svg85.svg";
import svg92 from "../../../../assets/svg/svg92.svg";

import { useNavigate } from "react-router-dom";
import ShareJobModal from "../../../recruitment/jobs/add/modal/ShareJobModal";
import { useSelector } from "react-redux";
function ViewList() {
  const navigate = useNavigate();
  const handleApply = async () => {
    await navigate("/recruitment/application-stepper");
  };
  const [openMarks, setOpenMarks] = useState(false);
  const handleOpenMarks = async (item) => {
    await setOpenMarks(true);
  };
  const handleCloseMarks = async () => {
    await setOpenMarks(false);
  };
  const { activeObjJob } = useSelector((state) => ({
    activeObjJob: state.folder.activeObj["job"],
  }));
  return (
    <>
      <div className="dark_card py-[2rem] px-[2rem] lg:w-[50rem] w-full">
        <DescriptionView />
        <DetailsView />
        <EmployementTermsView />

        <div className="flex items-center justify-between w-full mt-[2.5rem]">
          <div
            className="flex items-center text-[#706F6F] text-[.875rem] font-[400] font-dmSans gap-3 cursor-pointer"
            onClick={() => navigate("/recruitment/career-list")}
          >
            <img src={svg85} alt="svg85" /> Back
          </div>
          <div className="justify-end flex items-center gap-x-2">
            <div className="w-[100px]">
              <button
                key="back"
                type="button"
                className="cstm-btn-2"
                onClick={handleOpenMarks}
              >
                Share
              </button>
            </div>

            <div className="w-[120px]">
              <button
                key="submit"
                type="submit"
                className="cstm-btn"
                onClick={handleApply}
              >
                <span className="flex items-center  gap-x-3 ">
                  {" "}
                  Apply <img src={svg92} alt="svg92" />
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <ShareJobModal
        open={openMarks}
        handleCancel={handleCloseMarks}
        activeObjJob={activeObjJob}
      />
    </>
  );
}

export default ViewList;
